import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

export const breakStorageKey = 'break';
export const registrationDataStorageKey = 'registration-data';
export const scanFlowRegistrationDataStorageKey = 'scan-flow-registration-data';
export const manualFlowRegistrationDataStorageKey = 'manual-flow-registration-data';
export const resultRegistrationFlowRegistrationDataStorageKey = 'result-registration-flow-registration-data';
export const scanFlowScheduledRegistrationDateStorageKey = 'scan-flow-scheduled-registration-date';
export const containerMeasurementDataStorageKey = 'container-measurement-data';

@Injectable({ providedIn: 'root' })
export class StorageService {
    private storage = inject(LocalStorageService);

    get<TStorageItem>(key: string): TStorageItem | undefined {
        return this.storage.retrieve(key);
    }

    store<TStorageItem>(key: string, item: TStorageItem): void {
        if (item === undefined) {
            this.storage.clear(key);
        } else {
            this.storage.store(key, item);
        }
    }

    clear(key?: string): void {
        this.storage.clear(key);
    }
}
